import React, { useState } from 'react';
import '../../Stylesheets/Auth/OnboardingForm.css';
import Step1Image from '../../assets/images/OnboardingStep1.png';
import Step2Image from '../../assets/images/OnboardingStep2.png';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_ROUTES } from '../../Redux/Constants/apiRoutes';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserProfile } from '../../Redux/Auth/authSlice';

const OnboardingForm = () => {

  const dispatch = useDispatch();



  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    companyName: '',
    companySize: '',
    role: '',
    experience: '',
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSelect = (key, value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };

  const handleFinalSubmit = async () => {
    if (!formData.role || !formData.experience || !formData.companySize) {
      alert('Please fill all required fields');
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const updates = {
        ...formData,
        onboardingDone: true, // optional, will be handled in backend too
        from: 'onboarding',
      };
     await dispatch(updateUserProfile({ token, updates }));

      navigate('/dashboard');
    } catch (err) {
      alert('Something went wrong.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="onboarding-container">
      <div className="onboarding-illustration">
        <img
          src={step === 1 ? Step1Image : Step2Image}
          alt="Onboarding Illustration"
          className="onboarding-img"
        />
      </div>

      <div className="onboarding-form-section">
        {step === 1 ? (
          <>
            <h2 className="onboarding-heading">Let’s Get to Know You</h2>
            <div className="onboarding-underline" />

            <div className="onboarding-field">
              <label className="onboarding-label">Role / Designation</label>
              <div className="onboarding-options">
                {['Civil Engineer', 'Site Engineer', 'Contractor'].map((role) => (
                  <button
                    key={role}
                    className={`onboarding-option-btn ${formData.role === role ? 'selected' : ''}`}
                    onClick={() => handleSelect('role', role)}
                  >
                    {role}
                  </button>
                ))}
              </div>
            </div>

            <div className="onboarding-field">
              <label className="onboarding-label">Experience Level</label>
              <div className="onboarding-options">
                {['Beginner', 'Intermediate', 'Expert'].map((level) => (
                  <button
                    key={level}
                    className={`onboarding-option-btn ${formData.experience === level ? 'selected' : ''}`}
                    onClick={() => handleSelect('experience', level)}
                  >
                    {level}
                  </button>
                ))}
              </div>
            </div>

            <div className="onboarding-footer">
              <button className="onboarding-submit-btn" onClick={() => setStep(2)}>
                Continue
              </button>
            </div>
          </>
        ) : (
          <>
            <h2 className="onboarding-heading">Tell Us About Your Organization</h2>
            <div className="onboarding-underline" />

            <div className="onboarding-field">
              <label className="onboarding-label">Company Name (Optional)</label>
              <input
                type="text"
                name="companyName"
                placeholder="Enter your Company name"
                className="onboarding-input"
                value={formData.companyName}
                onChange={handleInputChange}
              />
            </div>

            <div className="onboarding-field">
              <label className="onboarding-label">Company Size</label>
              <div className="onboarding-options">
                {['0-10', '10-50', '50+'].map((size) => (
                  <button
                    key={size}
                    className={`onboarding-option-btn ${formData.companySize === size ? 'selected' : ''}`}
                    onClick={() => handleSelect('companySize', size)}
                  >
                    {size}
                  </button>
                ))}
              </div>
            </div>

            <div className="onboarding-footer">
              <button
                className="onboarding-submit-btn black"
                onClick={handleFinalSubmit}
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Finish'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OnboardingForm;
